export default function toListSentence(items: Array<string>): string {
  if (items.length < 3) {
    return items.join(' and ');
  }

  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}
